PJQ.models.submittals.Submittals = PJQ.models.BaseModel.extend({
    idAttribute: "submittalId",
    endpoint: function (urlOptions) {
        let arr;
        if (this.isNew() && this.get('projectId') > 0) {
            arr = [
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'submittals',
                    value: this.id
                }
            ];
        } else if (this.isNew() && this.get('templateId') > 0) {
            arr = [
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'templates',
                    value: this.get('templateId')
                },
                {
                    endpoint: 'submittals'
                }
            ];
        } else {
            arr = [
                {
                    endpoint: 'submittals',
                    value: this.id
                }
            ];
        }

        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    afterInit: function () {
        if (this.get('customFieldValues') == null) {
            this.set('customFieldValues', [], {
                silent: true
            });
        }
    },
    parse: function (model) {
        model = _.defaults(model, {});

        if (_.size(model.itemTypes) > 0) {
            this.itemTypes = new PJQ.collections.submittals.ItemTypes(model.itemTypes);
        } else if (!this.groups) {
            this.itemTypes = new PJQ.collections.submittals.ItemTypes();
        }

        if (_.size(model.groups) > 0) {
            this.groups = new PJQ.collections.groups.Groups(model.groups);
        } else if (!this.groups) {
            this.groups = new PJQ.collections.groups.Groups();
        }

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        } else {
            this.createdBy = null;
        }

        if (model.ballInCourt != null) {
            this.ballInCourt = new PJQ.models.projectContacts.ProjectContact(model.ballInCourt);
        } else {
            this.ballInCourt = null;
        }

        if (model.submitter != null) {
            this.submitter = new PJQ.models.projectContacts.ProjectContact(model.submitter);
        } else {
            this.submitter = null;
        }

        if (model.manager != null) {
            this.manager = new PJQ.models.projectContacts.ProjectContact(model.manager);
        } else {
            this.manager = null;
        }

        this.workflow = new PJQ.models.submittals.Workflow(model.workflow);

        // this.approvers = new PJQ.collections.projectContacts.ProjectContacts(model.approvers);

        if (_.size(model.distributionList) > 0) {
            this.distributionList = new PJQ.collections.projectContacts.ProjectContacts(model.distributionList);
        } else if (!this.distributionList) {
            this.distributionList = new PJQ.collections.projectContacts.ProjectContacts();
        }

        if (_.size(model.comments) > 0) {
            this.comments = new PJQ.collections.submittals.Comments(model.comments);
        } else if (!this.comments) {
            this.comments = new PJQ.collections.submittals.Comments();
        }

        if (_.size(model.attachments) > 0) {
            this.attachments = new PJQ.collections.submittals.Attachments(model.attachments);
        } else if (!this.attachments) {
            this.attachments = new PJQ.collections.submittals.Attachments();
        }

        return model;
    },
    statusShouldLock: function (statuses) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId);
        return status && status.get('shouldLock');
    },
    isNewStatus: function (statuses) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId);
        return status && status.get('type') === PJQ.constants.submittals.statusTypes.NEW;
    },
    isSubmittedStatus: function (statuses) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId);
        return status && status.get('type') === PJQ.constants.submittals.statusTypes.SUBMITTED;
    },
    isApprovedStatus: function (statuses) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId);

        if (status.get('type') === PJQ.constants.submittals.statusTypes.SUBMITTED) {
            // todo: check for submitted status type & partially approved
        }

        return status && status.get('type') === PJQ.constants.submittals.statusTypes.APPROVED;
    },
    isRejectedStatus: function (statuses) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId);
        return status && status.get('type') === PJQ.constants.submittals.statusTypes.REJECTED;
    },
    isVoidStatus: function (statuses) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId);
        return status && status.get('type') === PJQ.constants.submittals.statusTypes.VOID;
    },
    isPartiallyApproved: function () {
        return null != _.find(this.get('approvers'), (approver) => {
            return !approver.hasApproved;
        }) && null != _.find(this.get('approvers'), (approver) => {
            return approver.hasApproved;
        });
    },
    getStatusColor: function (statuses) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId),
            statusType = status.get('type');
        if (status == null) {
            // should never ever happen
            return '#000000';
        } else if (this.get('isClosed') && statusType === PJQ.constants.submittals.statusTypes.SUBMITTED) {
            return PJQ.constants.colors.RED;
        }

        if (statusType === PJQ.constants.submittals.statusTypes.SUBMITTED && this.isPartiallyApproved()) {
            return PJQ.constants.colors.PURPLE;
        }

        return PJQ.constants.submittals.statusTypeColors[status.get('type')];
    },
    getStatusName: function (settings, statuses, options = {}) {
        let statusId = this.get('statusId'),
            status = statuses.get(statusId),
            statusType = status.get('type');
        if (status == null) {
            // should never ever happen
            return 'New';
        } else if (this.get('isClosed') && statusType === PJQ.constants.submittals.statusTypes.SUBMITTED) {
            return 'Closed';
        }

        let result = status.get('name');
        if (statusType === PJQ.constants.submittals.statusTypes.SUBMITTED && this.isPartiallyApproved()) {
            let approveStatusName = settings.getApproveStatusName('ed');
            return 'Partially ' + approveStatusName;
        }

        // todo: add 'as noted" if asNoted is enabled and asNotedCommentId is set
        if (status.get('asNoted') && this.get('asNotedCommentId') > 0 && (!options || options.includeAsNoted !== false) && -1 === result.toLowerCase().indexOf("as noted")) {
            result += ' as noted';
        }

        return result;
    },
    beforeSave: function () {
        this.set({
            groups: this.groups.toJSON(),
            itemTypes: this.itemTypes.toJSON(),
            submitter: this.submitter ? this.submitter.toJSON() : null,
            manager: this.manager ? this.manager.toJSON() : null,
            // approvers: this.approvers.toJSON(),
            distributionList: this.distributionList.toJSON(),
            attachments: this.attachments.toJSON(),
            comments: this.comments.toJSON()
        });
    },
    approve: function (status, behalfId, callback) {
        this.beforeSave();

        let ep = this.endpoint() + '/approve';
        if (behalfId && behalfId != 0) {
            ep += '?behalf=' + behalfId.toString();
        }
        if (status && status != 0) {
            ep += '?approveStatus=' + status.toString();
        }
        new PJQ.ajax.Request({
            endpoint: ep,
            data: this.toJSON()
        }).post().done((response) => {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    void: function (status, callback) {
        let prevStatus = this.get('statusId');
        if (status > 0) {
            this.set('statusId', status);
        }

        this.beforeSave();
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/void',
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail((res) => {
            this.set('statusId', prevStatus);

            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    reject: function (status, callback) {
        let prevStatus = this.get('statusId');
        if (status > 0) {
            this.set('statusId', status);
        }

        this.beforeSave();
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/reject',
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail((res) => {
            this.set('statusId', prevStatus);

            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    submit: function (status, callback) {
        let prevStatus = this.get('statusId');
        if (status > 0) {
            this.set('statusId', status);
        }

        this.beforeSave();
        if (this.id > 0) {
            new PJQ.ajax.Request({
                endpoint: this.endpoint() + '/submit',
                data: this.toJSON()
            }).post().done(_.bind(function (response) {
                this.reset(response);
                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this)).fail((res) => {
                this.set('statusId', prevStatus);

                let err = null;
                if (res.responseJSON && res.responseJSON.message) {
                    err = res.responseJSON.message;
                }
                if (typeof callback === 'function') {
                    callback(false, err);
                }
            });
        } else {
            this.save(null, {
                notify: false,
                success: function () {
                    if (typeof callback === 'function') {
                        callback(true);
                    }
                },
                error: (model, res) => {
                    this.set('statusId', prevStatus);

                    let err = null;
                    if (res.responseJSON && res.responseJSON.message) {
                        err = res.responseJSON.message;
                    }

                    if (typeof callback === 'function') {
                        callback(false, err);
                    }
                }
            })
        }
    },
    respond: function (response, behalfId, callback) {
        this.beforeSave();

        let ep = this.endpoint() + '/respond';
        if (behalfId && behalfId != 0) {
            ep += '?behalf=' + behalfId.toString();
        }

        new PJQ.ajax.Request({
            endpoint: ep,
            data: response.toJSON()
        }).post().done((response) => {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    setBallInCourt: function (stepId, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/ballincourt' + '?stepId=' + stepId
        }).post().done((response) => {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    close: function (opts, callback) {
        let qs = '?distribute=' + (opts.distribute === true).toString();
        if (opts.status && opts.status > 0) {
            qs += '&statusId=' + opts.status.toString();
        }
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/close' + qs,
        }).post().done((response) => {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    reopen: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/reopen',
        }).post().done((response) => {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    distribute: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/distribute',
        }).post().done((response) => {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    isUserCurrentApprover: function (approvalMode, user) {
        if (!user) {
            if (approvalMode === PJQ.constants.submittals.approvalModes.SEQUENTIAL) {
                return this.get('isNextApprover') && !this.get('hasApproved');
            }

            return this.get('isApprover') && !this.get('hasApproved');
        }

        let result = false;
        if (approvalMode === PJQ.constants.submittals.approvalModes.SEQUENTIAL) {
            let foundNextApprover = false;
            _.each(this.get('approvers'), function (approver) {
                if (foundNextApprover || approver.hasApproved) {
                    return;
                }

                if (approver.id === user.get('id')) {
                    result = true;
                }
                foundNextApprover = true;
            })
        } else {
            result = null != _.findWhere(this.get('approvers'), {id: user.get('id'), hasApproved: false});
        }
        return result;
    },
    getRemainingApprovers: function () {
        return _.filter(this.get('approvers'), (approver) => {
            return !approver.hasApproved;
        })
    },
    isLastApprover: function (approvalMode, user) {
        if (!user) {
            if (approvalMode === PJQ.constants.submittals.approvalModes.SEQUENTIAL) {
                return _.size(this.get('approvers')) === 0 || this.get('isLastApprover');
            }

            return _.size(this.getRemainingApprovers()) <= 1;
        }

        return _.indexOf(this.get('approvers'), user.get('id')) === this.get('approvers').length - 1;
    },
    fetchNotifications: function (callback) {
        if (this.notifications == null) {
            this.notifications = new PJQ.collections.submittals.Notifications(null, {
                submittal: this
            })
        }

        this.notifications.fetch({
            success: _.bind(function () {
                callback(this.notifications);
            }, this)
        });
    },
    fetchEditHistory: function (callback) {
        if (this.editHistory == null) {
            this.editHistory = new PJQ.collections.submittals.EditHistory(null, {
                submittal: this
            })
        }

        this.editHistory.fetch({
            success: _.bind(function () {
                callback(this.editHistory);
            }, this)
        });
    },
});

PJQ.models.submittals.Attachment = PJQ.models.files.File.extend({
    idAttribute: 'attachmentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals',
                value: this.get('submittalId')
            },
            {
                endpoint: 'attachments',
                value: this.id
            }
        ]);
    }
});

PJQ.models.submittals.WorkflowTemplate = PJQ.models.BaseModel.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'workflows',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (model == null) {
            model = {};
        }

        this.workflow = new PJQ.models.submittals.Workflow(model.workflow);
        return model;
    },
    beforeSave: function () {
        this.set({
            workflow: this.workflow.toJSON()
        });
    },
});

PJQ.models.submittals.Workflow = PJQ.models.BaseModel.extend({
    parse: function (model) {
        if (model == null) {
            model = {};
        }

        this.steps = new PJQ.collections.submittals.WorkflowSteps(model.steps);

        return model;
    },
    clone: function () {
        let cloned = PJQ.models.BaseModel.prototype.clone.call(this);
        cloned.set({
            submittalId: null,
            templateId: null
        });
        _.each(cloned.steps.models, (step) => {
            step.set({
                id: null,
                isActive: false
            })

            let newApprovers = _.map(step.approvers.models, (approver) => {
                return {
                    stepId: approver.get('stepId'),
                    person: approver.get('person'),
                    personId: approver.get('personId'),
                    isRequired: approver.get('isRequired'),
                }
            });
            step.approvers.reset(newApprovers);
        });
        return cloned;
    },
    beforeSave: function () {
        this.set('steps', this.steps.toJSON());
    },
    toJSON: function () {
        this.beforeSave();
        return PJQ.models.BaseModel.prototype.toJSON.call(this);
    },
    getCurrentStep: function () {
        return this.steps.findWhere({isActive: true});
    }
});

PJQ.models.submittals.WorkflowStep = PJQ.models.BaseModel.extend({
    parse: function (model) {
        model = _.defaults(model, {});

        this.approvers = new PJQ.collections.submittals.WorkflowApprovers(model.approvers);

        return model;
    },
    beforeSave: function () {
        this.set('approvers', this.approvers.toJSON());
    },
    toJSON: function () {
        this.beforeSave();
        return PJQ.models.BaseModel.prototype.toJSON.call(this);
    }
});

PJQ.models.submittals.WorkflowApprover = PJQ.models.BaseModel.extend({});

PJQ.models.submittals.WorkflowResponse = PJQ.models.BaseModel.extend({
    parse: function (model) {
        model = _.defaults(model, {});

        this.attachments = new PJQ.collections.submittals.Attachments(model.attachments);

        return model;
    },
    beforeSave: function () {
        this.set({
            attachments: this.attachments.toJSON()
        });
    },
    toJSON: function () {
        this.beforeSave();
        return PJQ.models.BaseModel.prototype.toJSON.call(this);
    }
});

PJQ.models.submittals.Notification = PJQ.models.notifications.Notification.extend({
    notificationTypeNames: PJQ.constants.submittals.notificationTypeNames,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals',
                value: this.collection.options.submittal.id
            },
            {
                endpoint: 'notifications',
                value: this.id
            }
        ])
    }
});

PJQ.models.submittals.Comment = PJQ.models.BaseModel.extend({
    notifyName: 'Comment',
    idAttribute: 'commentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals',
                value: this.get('submittalId')
            },
            {
                endpoint: 'comments',
                value: this.id
            }
        ]);
    }
});

PJQ.models.submittals.EditHistoryItem = PJQ.models.BaseModel.extend({
    idAttribute: 'auditId'
});

PJQ.models.submittals.ItemType = PJQ.models.BaseModel.extend({
    idAttribute: 'itemTypeId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'itemtypes',
                value: this.id
            }
        ]);
    }
});

PJQ.models.submittals.Settings = PJQ.models.BaseModel.extend({
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.get('projectId') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'settings'
            }
        ]);
    },
    parse: function (model) {
        model = _.defaults(model, {});

        if (model) {
            if (_.size(model.defaultDistributionList) > 0) {
                this.defaultDistributionList = new PJQ.collections.projectContacts.ProjectContacts(model.defaultDistributionList);
            } else if (!this.defaultDistributionList) {
                this.defaultDistributionList = new PJQ.collections.projectContacts.ProjectContacts();
            }

            if (model.defaultManager != null) {
                this.defaultManager = new PJQ.models.projectContacts.ProjectContact(model.defaultManager);
            } else {
                this.defaultManager = null;
            }
        }

        return model;
    },
    beforeSave: function () {
        this.set({
            defaultManager: this.defaultManager ? this.defaultManager.toJSON() : null,
            defaultDistributionList: this.defaultDistributionList.toJSON()
        });
    },
    getApproveStatusName: function (suffix) {
        let statusName = this.get('approveNameOverride');
        if (_.size(statusName) === 0) {
            statusName = "Approve";
        }

        if (_.size(suffix) > 0) {
            // if suffix starts with "e", and status name ends with "e"
            // trim the preceding "e" from the suffix
            if (suffix[0].toLowerCase() === "e" && statusName[statusName.length - 1].toLowerCase() === "e") {
                suffix = suffix.substring(1);
            }

            statusName += suffix;
        }

        return statusName;
    }
});

PJQ.models.submittals.Status = PJQ.models.BaseModel.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'statuses',
                value: this.id
            }
        ]);
    }
});

PJQ.models.submittals.SubmittalUserSettings = PJQ.models.BaseModel.extend({
    endpoint: function () {
        let params = [];
        if (this.options.forCompany) {
            params.push({
                parameter: 'forCompany',
                value: true
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ], params);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.submittals.SubmittalCustomField = PJQ.models.customFields.CustomField.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'customFields',
                value: this.id
            }
        ]);
    },
});

PJQ.models.submittals.Template = PJQ.models.BaseModel.extend({
    idAttribute: 'templateId',
    notifyName: 'Template',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'templates',
                value: this.id
            }
        ], this.get('projectId') > 0 ? [
            {
                parameter: 'projectId',
                value: this.get('projectId')
            },
            {
                parameter: 'copyComments',
                value: this.get('copyComments')
            },
            {
                parameter: 'copySubmitter',
                value: this.get('copySubmitter')
            },
            {
                parameter: 'copyApprovers',
                value: this.get('copyApprovers')
            },
            {
                parameter: 'copyGroups',
                value: this.get('copyGroups')
            },
            {
                parameter: 'copyDistribution',
                value: this.get('copyDistribution')
            },
            {
                parameter: 'copyItemTypes',
                value: this.get('copyItemTypes')
            },
            {
                parameter: 'overwrite',
                value: this.get('overwrite')
            }
        ] : null);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.project != null) {
            this.project = model.project;
        } else {
            this.user = PJQ.app.session.user;
        }

        this.itemTypes = new PJQ.collections.submittals.ItemTypes(model.itemTypes);

        this.groups = new PJQ.collections.groups.Groups(model.groups);

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        } else {
            this.createdBy = null;
        }

        if (model.ballInCourt != null) {
            this.ballInCourt = new PJQ.models.projectContacts.ProjectContact(model.ballInCourt);
        } else {
            this.ballInCourt = null;
        }

        if (model.submitter != null) {
            this.submitter = new PJQ.models.projectContacts.ProjectContact(model.submitter);
        } else {
            this.submitter = null;
        }

        this.approvers = new PJQ.collections.projectContacts.ProjectContacts(model.approvers);

        this.distributionList = new PJQ.collections.projectContacts.ProjectContacts(model.distributionList);

        this.comments = new PJQ.collections.submittals.Comments(model.comments);

        this.attachments = new PJQ.collections.submittals.Attachments(model.attachments);

        if (model.submittals)
            this.submittals = new PJQ.collections.submittals.Submittals(model.submittals);

        else
            this.submittals = new PJQ.collections.submittals.Submittals();

        return model;
    }
});

PJQ.collections.submittals = {};
PJQ.collections.submittals.Submittals = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.Submittals,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'submittals'
            }
        ])
    }
});

PJQ.collections.submittals.WorkflowTemplates = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.WorkflowTemplate,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'workflows'
            }
        ]);
    }
});

PJQ.collections.submittals.WorkflowSteps = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.WorkflowStep
});

PJQ.collections.submittals.WorkflowApprovers = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.WorkflowApprover
});

PJQ.collections.submittals.Attachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.submittals.Attachment,
});

PJQ.collections.submittals.Comments = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.Comment
});

PJQ.collections.submittals.EditHistory = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.EditHistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals',
                value: this.options.submittal.id
            },
            {
                endpoint: 'edithistory'
            }
        ]);
    }
});

PJQ.collections.submittals.ItemTypes = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.ItemType,
    endpoint: function () {
        if (this.options.project != null) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'itemTypes'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'itemTypes'
                }
            ]);
        }

    }
});

PJQ.collections.submittals.Statuses = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.Status,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'statuses'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'statuses'
                }
            ]);
        }
    },
    copy: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'statuses'
                },
                {
                    endpoint: 'copy'
                }
            ])
        }).post().done(_.bind(function (response) {
            callback(response);
        }, this));
    },
});

PJQ.collections.submittals.Notifications = PJQ.collections.notifications.Notifications.extend({
    model: PJQ.models.submittals.Notification,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals',
                value: this.options.submittal.id
            },
            {
                endpoint: 'notifications'
            }
        ])
    }
});

PJQ.collections.submittals.SubmittalCustomFields = PJQ.collections.customFields.CustomFields.extend({
    model: PJQ.models.submittals.SubmittalCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project ? this.options.project.id : null
            },
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'customFields'
            }
        ], [
            {
                parameter: 'masterUserId',
                value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
            }
        ]);
    }
});

PJQ.collections.submittals.SubmittalCustomField = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.SubmittalCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'customFields'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'submittals'
                },
                {
                    endpoint: 'customFields'
                }
            ],
            [
                {
                    parameter: 'masterUserId',
                    value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
                }
            ]);
    }
});

PJQ.collections.submittals.Templates = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.submittals.Template,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'submittals'
            },
            {
                endpoint: 'templates'
            }
        ]);
    }
});